import {
    Dropdown, IDropdownOption, TextField,
    initializeIcons
} from "@fluentui/react";
import { dropdownStyles, textFieldStyles } from "../../common/views/DefaultStyles";
import { Utils } from "../../common/views/Utils";
import { AccountPhoneModel } from "../models/AccountTypes";
import cambodiaLogo from "../../../assets/images/Cambodia.jpg";
import usaLogo from "../../../assets/images/USA.jpg";

initializeIcons();

type PhoneProps = {
    form: AccountPhoneModel;
    errorMessages: any;
    isRequired?: boolean;
    showTelegram: boolean;
    onValueChange: (field: keyof AccountPhoneModel, value: any) => void;
}
function PhoneView({ form, errorMessages, isRequired, showTelegram, onValueChange }: PhoneProps) {
    const width5 = Utils.getColumnWidth(5);
    const width7 = Utils.getColumnWidth(7);

    const countryCodeOptions: IDropdownOption[] = [
        { key: '855', text: '(+855)', data: { icon: cambodiaLogo } },
        { key: '1', text: '(+1)', data: { icon: usaLogo } }
    ];

    const onRenderTitle = (selectedOptions?: IDropdownOption[]) => {
        if (!selectedOptions || selectedOptions.length === 0) return null;

        const selectedOption = selectedOptions[0];

        return <>{displayValue(selectedOption)}</>;
    };

    const onRenderOption = (option?: IDropdownOption) => {
        if (!option) return null;

        return <>{displayValue(option)}</>;
    };

    const displayValue = (option: IDropdownOption) => {
        return <div style={{ display: 'flex', alignItems: 'center' }}>
            {option.data?.icon && (
                <img
                    src={option.data.icon}
                    alt=""
                    style={{ width: 25, height: 18, marginRight: 10 }}
                />
            )}
            <div style={{ marginTop: -2 }}>{option.text}</div>
        </div>;
    }

    return <div className="ms-Grid-row">
        <div className={width5}>
            <Dropdown
                label="Country Code"
                defaultSelectedKey={form.countryCode}
                options={countryCodeOptions}
                onRenderTitle={onRenderTitle}
                onRenderOption={onRenderOption}
                required={isRequired}
                onChange={(_, v) => onValueChange("countryCode", v?.key || "")}
                styles={dropdownStyles}
            />
        </div>
        <div className={width7 + " left"}>
            <TextField
                label="Phone #"
                value={form.phoneNo}
                required={isRequired}
                onChange={(_, v) => onValueChange("phoneNo", v || "")}
                errorMessage={errorMessages.phoneNo}
                styles={textFieldStyles} />
        </div>
    </div>;
}

export default PhoneView;